import Layout from 'components/common/Layout';
import Section1 from 'components/intro/Section1';
import Section2 from 'components/intro/Section2';
import Title from 'components/intro/Title';

const Intro = () => (
  <Layout theme="transparents" pd>
    <Title />
    <Section1 />
    <Section2 />
  </Layout>
);

export default Intro;
